<template>
<div class="free_book_data">
    <h4 class="title">평점</h4>
    <div class="contants">
        <div class="contants_pbox">
            <p class="people_count">
                프리북을 통해 지금까지<br><span>{{ total }}명</span> 고객을 만났습니다.
            </p>
            <div class="star_box">
                <p>{{reviewAvg}}</p>
                <star-rating
                    :rating="Number(reviewAvg)"
                    :increment="0.1"
                    :max-rating="5"
                    :fixed-points="1"
                    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                    inactive-color="#E9EAEC"
                    active-color="#FFE78A"
                    :star-size="26"
                    text-class = ''
                    read-only>
                </star-rating>
            </div>
            <!--
            <div class="chart">
                <div>
                    <span class="good" :style="`width: ${rateGood}%;`"></span>
                    <span class="soso" :style="`width: ${rateNormal}%;`"></span>
                    <span class="bad" :style="`width: ${rateBad}%;`"></span>
                </div>
                <ul>
                    <li>
                        <span></span>
                        <dl>
                            <dt>만족</dt>
                            <dd>{{ rateGood }}%</dd>
                        </dl>
                    </li>
                    <li>
                        <span></span>
                        <dl>
                            <dt>보통</dt>
                            <dd>{{ rateNormal }}%</dd>
                        </dl>
                    </li>
                    <li>
                        <span></span>
                        <dl>
                            <dt>불만족</dt>
                            <dd>{{ rateBad }}%</dd>
                        </dl>
                    </li>
                </ul>
            </div>-->
            <ul class="reviews_type" v-if="bestDetail[0].count > 0">
                <li>{{ bestDetail[0].title }} <span><img :src="$store.state.resource.imgIconGood">{{ bestDetail[0].count }}</span></li>
                <li v-if="bestDetail[1].count > 0">{{ bestDetail[1].title }} <span><img :src="$store.state.resource.imgIconGood">{{ bestDetail[1].count }}</span></li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import { NumberFormatMixin } from '../../mixins/NumberFormatMixin';
import StarRating  from "vue-star-rating";
    export default {
        name:'ReviewData',
        mixins: [ NumberFormatMixin ],
        components: { 
            StarRating
        },
        props: {
            total:          { type: Number },
            reviewTotal:    { type: Number },
            reviewCount:    { type: Number },
            reviewSum:      { type: Number },
            good:           { type: Number },
            normal:         { type: Number },
            bad:            { type: Number },
            detailA:        { type: Number },
            detailB:        { type: Number },
            detailC:        { type: Number },
            detailD:        { type: Number },
            detailE:        { type: Number },
            detailF:        { type: Number },
            typeSc:         { type: Boolean, default: false },
            typeShop:       { type: Boolean, default: false },
            typeTrim:       { type: Boolean, default: false },
        },
        computed: {
            REVIEW_DETAIL_SCORE() {
                let codeDictionary = this.$store.state.codeDictionary.items;
                let result = {};

                if(this.typeSc)
                    result = codeDictionary.REVIEW_SC_DETAIL_SCORE;
                else if(this.typeShop)
                    result = codeDictionary.REVIEW_SHOP_DETAIL_SCORE;
                else if(this.typeTrim)
                    result = codeDictionary.REVIEW_TRIM_DETAIL_SCORE;

                return result;
            },
            rateGood() {
                return this.$_getRateGood(this.good, this.normal, this.bad);
            },
            rateNormal() {
                return this.$_getRateNormal(this.good, this.normal, this.bad);
            },
            rateBad() {
                return this.$_getRateBad(this.good, this.normal, this.bad);
            },
            bestDetail() {
                let result = [];
                let detailScore = [
                    this.detailA
                    , this.detailB
                    , this.detailC
                    , this.detailD
                    , this.detailE
                    , this.detailF
                ]

                result = this.$_getRankingList(detailScore);

                result.forEach( (item) => {
                    item.title = this.REVIEW_DETAIL_SCORE[item.type].title;
                })
                
                return result;
            },
            reviewAvg() {
                return this.reviewRatingAvg(this.reviewSum, this.reviewTotal);
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>